import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=34cef7a8&"
import script from "./IconList.vue?vue&type=script&lang=js&"
export * from "./IconList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IconList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VList,
  VListTile,
  VListTileAvatar,
  VListTileContent,
  VListTileSubTitle,
  VListTileTitle,
})
